import { useSelector } from 'react-redux';

import { EVerificationStatus } from '@r1-frontend/entities/ContactAddress/initialState';

import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';

import { useAnalytics } from '~/src/features/full-buy/analytics/context';
import { BannerView } from '~/src/features/full-buy/Banner/BannerView';
import {
    useCheckAdditionalEquipment,
} from '~/src/features/full-buy/containers/AdditionalEquipment/useCheckAdditionalEquipment';
import { selectBannerInfoForFullBuy } from '~/src/features/full-buy/store/selectors/selectBannerInfoForFullBuy';
import { TState } from '~/src/store';

export const Banner = () => {
    // todo- удалить свойство hasAdditionalEquipment из хука,
    //  когда будет отвязан баннер от AdditionalEquipment
    const { hasAdditionalEquipment } = useCheckAdditionalEquipment();

    const banner = useSelector(selectBannerInfoForFullBuy);
    const verifiedAddressDataStatus = useSelector((state: TState) => state.contactAddress.verifiedAddressData.status);
    const analytics = useAnalytics();

    const isAddressNotVerified = verifiedAddressDataStatus === EVerificationStatus.notVerified;

    if (!banner || hasAdditionalEquipment || !isAddressNotVerified) {
        return null;
    }

    const onClickHandle = () => {
        analytics.clickBanner(banner.tariffName);
        location.href = banner.path;
    };

    return (
        <IndentContainer $united={[40, 0, 8]}>
            <BannerView
                title={banner.title}
                subtitle={banner.subtitle}
                onClick={onClickHandle}
            />
        </IndentContainer>
    );
};
